import React from "react";
import MerchantLayout from "../../components/MerchantLayouts";
import MerchantProfile from "../../components/MemberShipProfile/MembershipProfile";

const MerchantProfilePage = () => {
  return (
    <MerchantLayout>
      <MerchantProfile />
    </MerchantLayout>
  ); 
};

export default MerchantProfilePage;
